import { readLocalStorageValue } from '@mantine/hooks';
import { useLocation } from 'react-router';

export function useWasLoggedInBefore() {
  const location = useLocation();
  const lastUserId = readLocalStorageValue({ key: 'uid' });

  return location.pathname === '/' && !!lastUserId;
}
